import { DistributionChannel } from 'model/DistributionChannel';
import { createSelector } from 'reselect';

import { selectIsNewQuestionsEndpointEnabled } from './featureFlagSelector';
import { selectMeta } from './metaResourceSelector';
import { selectDistributionSlug } from './navigationSelector';
import { selectSurvey } from './surveySelector';

// CLEANUP-L1S-1606: legacy lookup, remove with the flag
export const selectDistribution = createSelector(
  selectDistributionSlug,
  selectSurvey,
  (distributionSlug, survey) =>
    survey &&
    survey
      .getDistributions()
      .find(
        (distribution) =>
          distribution.getSlug() === distributionSlug || distribution.getId() === distributionSlug
      )
);

const createIsDistributionChannelSelector = (channel: DistributionChannel) =>
  createSelector(
    selectIsNewQuestionsEndpointEnabled,
    selectMeta,
    selectDistribution,
    (isNewQuestionsEndpointEnabled, meta, distribution) =>
      isNewQuestionsEndpointEnabled
        ? meta?.getDistributionChannel() === channel
        : distribution && distribution.getChannel() === channel
  );

export const selectIsEmailDistribution = createIsDistributionChannelSelector(
  DistributionChannel.Email
);

export const selectIsWebLinkDistribution = createIsDistributionChannelSelector(
  DistributionChannel.WebLink
);

export const selectIsKioskDistribution = createIsDistributionChannelSelector(
  DistributionChannel.Kiosk
);

export const selectIsPaperDistribution = createIsDistributionChannelSelector(
  DistributionChannel.Paper
);
